import React from 'react';
import config from '../config';
import PlanPage from './PlanPage';

function GymChains() {
  return (
    <PlanPage
      title="Gym & Fitness Plans"
      subtitle="Fuel your workouts with premium nutrition — delivered at your gym."
      message="Power up your fitness journey with FALSUTRA's Gym Plans. Pre and post-workout fruit bowls packed with natural energy, delivered straight to your gym or fitness centre."
      plans={config.gymPlans}
    />
  );
}

export default GymChains;
